module.exports = __webpack_public_path__ + "static/media/patients.70b60f70.svg";